// ── 직원 등록·수정 창 칸 — 생년월일·연락처·mail / 입사·퇴사일자·연차 시작 차수·주소·계좌·메모·안내문 ──────
// 2026-11-03 UserModals.jsx(289줄)에서 그대로 옮겼다(300줄 규칙, 동작 변화 없음) — 등록 창 맨 위 '구분(4대보험/3.3%)' 칸을 넣기 전 정리.
import React from 'react';
import UserEffectiveHistoryFields from './UserEffectiveHistoryFields';
import LabeledField, { labeledInputStyle } from './LabeledField';
import { btn, helperTextStyle, gmailSuffixStyle } from './styles';
import { isNoId, formatPhone, onlyDigits } from './utils';

// 칸마다 안쪽 왼쪽에 항목 이름(2026-11-05 맵찔찔이님, LabeledField). 흐린 글자는 형식 안내만 남긴다.
// 칸 순서 = 맵찔찔이님 그림(2026-11-05): 아이디·비밀번호 / 이름·생년월일 / 연락처·mail / 부서·근무유형 / 입사·퇴사 / 연차·퇴직처리 / 주소 …
//   이름 바로 뒤에 오는 생년월일·연락처·mail 은 여기, 부서·근무유형 뒤에 오는 칸은 아래 UserDetailFields.
export function UserContactFields({ form, setForm }) {
  return (
    <>
      <LabeledField label="생년월일">
        <input
          style={labeledInputStyle()}
          placeholder="6자리"
          value={form.birth_date}
          maxLength={6}
          onChange={(e) => setForm({ ...form, birth_date: onlyDigits(e.target.value, 6) })}
        />
      </LabeledField>
      <LabeledField label="연락처">
        <input
          style={labeledInputStyle()}
          placeholder="010-0000-0000"
          value={form.phone}
          maxLength={13}
          onChange={(e) => setForm({ ...form, phone: formatPhone(e.target.value) })}
        />
      </LabeledField>
      <LabeledField label="mail">
        <input
          style={{ ...labeledInputStyle(), paddingRight: 92 }}
          placeholder="아이디"
          value={form.emailId}
          maxLength={60}
          onChange={(e) => setForm({ ...form, emailId: e.target.value.replace(/[^a-zA-Z0-9._-]/g, '') })}
        />
        <span style={gmailSuffixStyle}>@gmail.com</span>
      </LabeledField>
    </>
  );
}

// actionCell = 연차 시작 차수 옆 칸(퇴직처리·담당 해제, UserModals AccountActionCell)
export default function UserDetailFields({ form, setForm, editing, openAddressSearch, actionCell }) {
  return (
    <>
      {/* 입사·퇴사일자 — 칸 안쪽 라벨 (2026-08-27 사용자 명세: date 입력은 placeholder 불가) */}
      <LabeledField label="입사일자">
        <input
          style={labeledInputStyle()}
          type="date"
          value={form.hire_date}
          onChange={(e) => setForm({ ...form, hire_date: e.target.value })}
        />
      </LabeledField>
      <LabeledField label="퇴사일자">
        <input
          style={labeledInputStyle()}
          type="date"
          value={form.resign_date}
          onChange={(e) => setForm({ ...form, resign_date: e.target.value })}
        />
      </LabeledField>
      <LabeledField label="연차 시작 차수">
        <input
          style={labeledInputStyle(108)}
          type="number"
          step="1"
          min="0"
          value={form.first_year_grant_count}
          onChange={(e) => setForm({ ...form, first_year_grant_count: e.target.value })}
        />
      </LabeledField>
      {actionCell}
      <div style={{ gridColumn: '1 / -1', display: 'grid', gap: 8 }}>
        <div style={{ display: 'flex', gap: 8 }}>
          <LabeledField label="주소" style={{ flex: 1, minWidth: 0 }}>
            <input
              style={labeledInputStyle()}
              value={form.addressBase}
              onChange={(e) => setForm({ ...form, addressBase: e.target.value })}
            />
          </LabeledField>
          <button type="button" style={{ ...btn, whiteSpace: 'nowrap', flexShrink: 0 }} onClick={openAddressSearch}>주소검색</button>
        </div>
        <LabeledField label="상세주소">
          <input
            style={labeledInputStyle()}
            value={form.addressDetail}
            onChange={(e) => setForm({ ...form, addressDetail: e.target.value })}
          />
        </LabeledField>
      </div>
      <LabeledField label="은행명">
        <input
          style={labeledInputStyle()}
          value={form.bank_name}
          onChange={(e) => setForm({ ...form, bank_name: e.target.value })}
        />
      </LabeledField>
      <LabeledField label="계좌번호">
        <input
          style={labeledInputStyle()}
          placeholder="숫자만"
          value={form.bank_account}
          onChange={(e) => setForm({ ...form, bank_account: onlyDigits(e.target.value, 30) })}
        />
      </LabeledField>
      <UserEffectiveHistoryFields
        kind="bank"
        editing={editing}
        form={form}
        setForm={setForm}
      />
      <LabeledField label="메모" top style={{ gridColumn: '1 / -1' }}>
        <textarea
          style={{ ...labeledInputStyle(), height: 'auto', paddingTop: 9, paddingBottom: 9, minHeight: 74, display: 'block' }}
          value={form.memo}
          onChange={(e) => setForm({ ...form, memo: e.target.value })}
        />
      </LabeledField>
      {/* 하단 안내문 — 3줄 고정 정렬 (2026-08-27 사용자 명세) */}
      <div style={{ ...helperTextStyle, display: 'grid', gap: 3 }}>
        {!editing && (
          <>
            <span>아이디를 비우면 아이디 없음으로 등록되고, 수정 화면에서 나중에 설정할 수 있습니다.</span>
            <span>초기 비밀번호는 0214입니다.</span>
          </>
        )}
        {editing && isNoId(editing.user_id) && (
          <span>현재 아이디 없음 상태입니다. 이번 수정에서 최초 1회 아이디를 설정할 수 있습니다.</span>
        )}
        <span>기본은 입사 1년 미만 연차 정책입니다. 시작 차수 예시: 1=첫 지급 15, 2=첫 지급 15 다음 달 16.</span>
      </div>
    </>
  );
}
